import React, { useEffect } from "react";
import Grid from "@mui/material/Grid";
import MDBox from "components/MDBox";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import ComplexStatisticsCard from "examples/Cards/StatisticsCards/ComplexStatisticsCard";
import { useGetCountCategoryQuery } from "App/services/categoryServiceApi";
import { useGetCountSubCategoryQuery } from "App/services/subCategoryServiceApi";


import reportsLineChartData from "layouts/dashboard/data/reportsLineChartData";



function Dashboard() {
  const { sales, tasks } = reportsLineChartData;

  const { data: categories, isLoading, isFetching, isError, error } = useGetCountCategoryQuery({ refetchOnFocus: false });
  const { data: subCategories, isLoading: isLoadingSubCategories, isError: isErrorSubCategories } = useGetCountSubCategoryQuery({ refetchOnFocus: false });

  // Get category count
  let categoryCount = 0;
   if (categories) {
    categoryCount = categories.count || 0;
  }

  // Get Sub Category Count
  let subCategoryCount = 0;
   if (subCategories) {
    subCategoryCount = subCategories.count || 0;
  }

  

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox py={3}>
        <Grid container spacing={3}>
          <Grid item xs={12} md={6} lg={6}>
            <MDBox mb={1.5}>
              <ComplexStatisticsCard
                color="dark"
                icon="weekend"
                title="Category"
                count={categoryCount}
              />
            </MDBox>
          </Grid>
          <Grid item xs={12} md={6} lg={6}>
            <MDBox mb={1.5}>
              <ComplexStatisticsCard
                icon="leaderboard"
                title="Sub Category"
                count={subCategoryCount}
              />
            </MDBox>
          </Grid>
        </Grid>
        {/* Image Slider Component */}

      </MDBox>
      {/* <Footer /> */}
    </DashboardLayout>
  );
}

export default Dashboard;
